import { CircularProgress } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { apiGet } from '../../generic/Api_Functions'
import AlertUI from '../../generic/AlertUI'
import { useLocation } from 'react-router'
import DeviceGroupConfiguration from './DeviceGroupConfiguration'

const DeviceGroupSettings = () => {
  const { groupId } = useParams()
  const groupIdLong = parseInt(groupId, 10)
  const { state } = useLocation()
  const [deviceGroup, setDeviceGroup] = useState({})
  const [AlertElement, showAlert] = AlertUI()
  const show = useRef(showAlert)

  useEffect(() => {
    if (state === 'BACK') {
      show.current({ title: 'There have been no modifications.', severity: 'info' })
    } else if (state === 'EDIT') {
      show.current({ title: 'Updated correctly.', severity: 'success' })
    }
  }, [state])

  useEffect(() => {
    const fetchDeviceGroup = async () => {
      await apiGet('assetGroupConfiguration/' + groupIdLong).then((response) => {
        setDeviceGroup({ ...response })
      }).catch(() => {
        show.current({ title: 'Error fetching asset group data.', severity: 'error' })
      })
    }
    fetchDeviceGroup()
  }, [groupIdLong])

  // TODO: if device type not CELL, can´t edit configuration

  return (
    <>
      {AlertElement}
      {deviceGroup.id
        ? <DeviceGroupConfiguration deviceGroup={deviceGroup} setDeviceGroup={setDeviceGroup} />
        : <CircularProgress />}
    </>
  )
}

export default DeviceGroupSettings
